export default {
  SET_FREE_TRIAL_END_PERIOD: (state, payload) => {
    state.freeTrialEndPeriod = payload;
  },
  SET_ASSIGNEE: (state, payload) => {
    state.assignee = payload;
  },
};
